module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av4-b072be2bba8d31476f4d5ec40aefacec.jpg";